// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-chat-conversation-list {
  display: block;
}
.fi-chat-conversation-list .conversations-loading-container {
  margin-top: 20px;
}`, "",{"version":3,"sources":["webpack://./Source/app/shared/fi-chat/fi-chat-conversation-list/fi-chat-conversation-list/fi-chat-conversation-list.component.scss"],"names":[],"mappings":"AAAA;EACI,cAAA;AACJ;AAAI;EACI,gBAAA;AAER","sourcesContent":[".fi-chat-conversation-list {\r\n    display: block;\r\n    .conversations-loading-container {\r\n        margin-top: 20px;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
